<template>
<div class="chapter">
<div class="inner_page">
<p class="noindenti"><a id="page_vii"></a></p>
<h1 class="h1"><strong>THE DELIVERY MAN</strong></h1>
<p class="author">JOE McGINNISS JR.</p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3c58fd5e